export default {
  // 获取专题详细信息
  getSpecialContentById: '/member/anonymous/amc/getSpecialContentById',
  // 获取专题下的内容分类列表
  getSpecialById: '/member/anonymous/amc/listContentClassifyBySpecialId',
  // 专题内容列表接口
  getSpecialContentsByClassifyId: '/member/anonymous/amc/listSpecialContentsByContentClassifyId',
  // 获取专栏详细信息
  getSpecialContentsForColumn: '/member/anonymous/amc/getSpecialContentsForColumn',
}